/**
 * Types for GET /v1/authorization/assignedEmployees - Colaboradores con roles asignados (paginado)
 */

import type { LC_PagedResult } from '@/api/shared/types';


// ===== Pagination Constants =====

export const ROLE_ASSIGNED_EMPLOYEES_LIST_DEFAULT_PAGE_SIZE = 10;

// ===== Filter Types =====

export const ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER = {
  ALL: 'all',
  ENABLED: 'enabled',
  DISABLED: 'disabled',
} as const;

export type RoleAssignedEmployeesStatusFilter =
  typeof ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER[keyof typeof ROLE_ASSIGNED_EMPLOYEES_STATUS_FILTER];

// ===== Status Codes =====

// El backend entrega un código, no una etiqueta. La etiqueta visible sale de
// authorization:assigned.status.* y debe coincidir con los literales que el SQL usa
// en statusLabel para búsqueda y ordenamiento.
export const ROLE_ASSIGNED_EMPLOYEE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type RoleAssignedEmployeeStatus =
  typeof ROLE_ASSIGNED_EMPLOYEE_STATUS[keyof typeof ROLE_ASSIGNED_EMPLOYEE_STATUS];

// ===== Transport Types (Backend DTOs) =====

export interface LC_RoleAssignedEmployee {
  employeeTaxIdentificationNumber: string;
  employeeName: string;
  webRolesCount: number;
  mobileRolesCount: number;
  webRoleNames: string[];
  mobileRoleNames: string[];
  status: RoleAssignedEmployeeStatus;
}

export type LC_RoleAssignedEmployeesListOut = LC_PagedResult<LC_RoleAssignedEmployee>;

// ===== Domain Models (Internal) =====

export interface RoleAssignedEmployee {
  rut: string;
  name: string;
  webRolesCount: number;
  mobileRolesCount: number;
  webRoleNames: string[];
  mobileRoleNames: string[];
  status: RoleAssignedEmployeeStatus;
}

export interface RoleAssignedEmployeesListResult {
  items: RoleAssignedEmployee[];
  totalRecords: number;
}

export interface RoleAssignedEmployeesListFilters {
  page?: number;
  pageSize?: number;
  status?: RoleAssignedEmployeesStatusFilter;
  searchText?: string;
  orderBy?: string | null;
  orderDirection?: string | null;
  [key: string]: string | number | undefined | null;
}

// ===== Export Filters =====

export interface RoleAssignedEmployeesExportFilters {
  status?: RoleAssignedEmployeesStatusFilter;
  searchText?: string;
}
